import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PageCode } from '@gov-nx/module/page';
import { useMojeOsvedceniSeznamContextInstance } from '@gov-nx/module/page';
import {
	ContentLayout,
	InfoBanner,
	Pagination,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { scrollIntoView } from '@gov-nx/web';
import { MySubmissionsListSkeleton } from './MySubmissionsListSkeleton';
import { MyVerificationsListFilter } from './MyVerificationsListFilter';

export interface MyVerificationsViewProps {
	code: PageCode;
}

export const MyVerificationsList = ({ code }: MyVerificationsViewProps) => {
	const { t } = useTranslation([code]);
	const {
		verifications,
		filter,
		currentPage,
		goToPage,
		numberOfVerifications,
		query,
		handleVerificationDownload,
		controls,
	} = useMojeOsvedceniSeznamContextInstance();

	return (
		<ContentLayout customClasses="mt-6">
			<MyVerificationsListFilter code={code} />
			{query.isFetching ? (
				<MySubmissionsListSkeleton />
			) : (
				<section>
					{numberOfVerifications ? (
						<>
							<Tiles marginTop="l">
								{verifications.map((verification) => (
									<Tile
										key={verification.id}
										icon={{ name: 'download', type: 'templates', size: 'l' }}
										onClick={() => {
											handleVerificationDownload(verification.id);
										}}
										loading={
											controls.isDownloadVerificationId === verification.id
										}
										date={verification.issueDate}
										name={verification.addressee}>
										<p className="text-(--text-secondary)">
											{verification.name}, {t('osvedceni.id.nazev')}:{' '}
											{verification.id}
										</p>
									</Tile>
								))}
							</Tiles>
							{numberOfVerifications > filter.pocet ? (
								<footer className="mt-6">
									<Pagination
										color="primary"
										size="m"
										onPage={(page) => {
											scrollIntoView();
											goToPage(page);
										}}
										current={currentPage}
										pageSize={filter.pocet}
										total={numberOfVerifications}
										wcag-label={t('strankovani')}
									/>
								</footer>
							) : null}
						</>
					) : (
						<InfoBanner
							headline={t('osvedceni.stav.chyba.zadna-osvedceni')}
							text={t('osvedceni.stav.chyba.zrejme-jste-nic-nevytvorili')}
						/>
					)}
				</section>
			)}
		</ContentLayout>
	);
};
